import React, { FC } from 'react';

import { GalleryQuestion } from '../GalleryQuestion';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useQuestionSettings } from 'modules/budget/hooks/useQuestionSettings';

export const Q13: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q13;
  const { isMultiselect, isQuantityEnabled } = useQuestionSettings();

  return (
    <GalleryQuestion
      allowSelectQuantity={isQuantityEnabled(question)}
      multiselect={isMultiselect(question)}
      question={question}
    />
  );
};
